import * as Constants from "../../../consts/Constants.js";

import Api from "./api";
import auth from "../../auth/service";

const ADMIN_ROLE = 4651;

class ResiduesService {

	constructor(baseUrl) {
		this.api = new Api(baseUrl);
	}

	canAdmin() {
		return auth.hasRole(ADMIN_ROLE);
	}

}

export default new ResiduesService(Constants.FINAL_URL_RESIDUES);